import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hint", "size", "error", "classes", "className", "children", "endIcon", "startIcon", "disabled"];
import { ButtonBase, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: ColorDynamic.White,
    border: '1px dashed',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5),
    minHeight: theme.spacing(13),
    transition: theme.transitions.create(['color', 'box-shadow', 'border-color', 'background-color'])
  },
  disabled: {
    color: ColorDynamic.Dark100,
    borderColor: ColorDynamic.Silver500,
    backgroundColor: ColorDynamic.Silver400Alpha30,
    '& $hint': {
      color: ColorDynamic.Dark100
    }
  },
  error: {
    color: ColorDynamic.Red500,
    borderColor: ColorDynamic.Red500,
    backgroundColor: ColorDynamic.Red50,
    '&:focus': {
      backgroundColor: ColorDynamic.Red300Aplha20
    }
  },
  primary: {
    color: ColorDynamic.Blue500,
    borderColor: ColorDynamic.Silver500,
    '&:focus': {
      backgroundColor: ColorDynamic.Blue50
    },
    '&:hover, &:active': {
      borderColor: ColorDynamic.Blue300,
      backgroundColor: ColorDynamic.Blue50
    }
  },
  sizeSmall: {
    minHeight: theme.spacing(6)
  },
  sizeLarge: {
    minHeight: theme.spacing(17.5)
  },
  label: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    display: 'flex',
    '& svg': {
      fontSize: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.spacing(2.5)
      }
    }
  },
  startIcon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(-0.5)
  },
  endIcon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(-0.5)
  },
  hint: {
    marginTop: theme.spacing(0.5)
  }
}), {
  name: 'SD-CardButton'
});
export var CardButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      hint,
      size,
      error,
      classes,
      className,
      children,
      endIcon,
      startIcon,
      disabled
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles({
    classes
  });
  return /*#__PURE__*/_jsx(ButtonBase, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    disabled: disabled,
    className: clsx(styles.root, {
      [styles.disabled]: disabled,
      [styles.error]: !disabled && error,
      [styles.primary]: !disabled && !error,
      [styles.sizeSmall]: size === 'small',
      [styles.sizeLarge]: size === 'large'
    }, className),
    children: error ? /*#__PURE__*/_jsxs(Typography, {
      variant: "h4",
      color: "inherit",
      className: styles.label,
      children: [!!startIcon && /*#__PURE__*/_jsx("span", {
        className: clsx(styles.icon, styles.startIcon),
        children: startIcon
      }), error]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Typography, {
        variant: "h4",
        color: "inherit",
        className: styles.label,
        children: [!!startIcon && /*#__PURE__*/_jsx("span", {
          className: clsx(styles.icon, styles.startIcon),
          children: startIcon
        }), children, !!endIcon && /*#__PURE__*/_jsx("span", {
          className: clsx(styles.icon, styles.endIcon),
          children: endIcon
        })]
      }), !!hint && /*#__PURE__*/_jsx(Typography, {
        color: "textSecondary",
        variant: "caption",
        className: styles.hint,
        children: hint
      })]
    })
  }));
});
if (process.env.NODE_ENV !== "production") CardButton.displayName = "CardButton";